import React from "react";
import IronIcon from "./IronIcon";
import WasherIcon from "./WasherIcon";

/**
 * Entrambi i servizi: stiro + lavaggio
 */
export default function BothIcon({
  size = 12,
  color = "currentColor",
  strokeWidth = 2,
  gap = 4,
  ...props
}) {
  const sub = Math.round(size * 0.8);
  return (
    <div style={{ display: "flex", alignItems: "center", gap }} {...props}>
      <IronIcon size={sub} color={color} strokeWidth={strokeWidth} />
      <WasherIcon size={sub} color={color} strokeWidth={strokeWidth} />
    </div>
  );
}
